
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  props: ["toggle", "open"]
})
export default class MenuMobile extends Vue {
  async exportPayment() {
    const historyExport: any = await (this.$root as any)._post(
      "claims/exportpaymentsxls",
      {}
    );
    if (historyExport.path) {
      window.open(historyExport.path);
    }
  }
}
